
/*
 * CORATO - Botão de compra nas avaliações Areviews
 * Compatível com formulário de produto Shrine
 */

(() => {
  if (window.coratoAreviewsCartLoaded) return;
  window.coratoAreviewsCartLoaded = true;

  const BUTTON_CLASS = "corato-areviews-atc";

  const style = document.createElement("style");

  style.textContent = `
    .${BUTTON_CLASS} {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      width: 100%;
      min-height: 66px;
      margin-top: 10px;
      padding: 12px 14px;
      border: none;
      border-radius: 13px;
      background: #388C1D;
      color: #FFFFFF;
      font-family: inherit;
      font-size: 19px;
      font-weight: 800;
      letter-spacing: .5px;
      line-height: 1.2;
      text-align: center;
      cursor: pointer;
      transition: background .2s ease;
    }

    .${BUTTON_CLASS}:hover {
      background: #2E7418;
    }

    .${BUTTON_CLASS}:disabled {
      opacity: .65;
      cursor: wait;
    }

    .${BUTTON_CLASS} svg {
      width: 22px;
      height: 22px;
      flex-shrink: 0;
    }

    @media (max-width: 749px) {
      .${BUTTON_CLASS} {
        min-height: 60px;
        font-size: 16px;
        padding: 12px 10px;
        border-radius: 12px;
      }
    }
  `;

  document.head.appendChild(style);

  function getProductForm() {
    return Array.from(
      document.querySelectorAll("product-form")
    ).find((element) => {
      return (
        element.querySelector("form") &&
        element.querySelector('button[type="submit"]') &&
        !element.closest("quick-add-modal")
      );
    });
  }

  function addButton(modal) {
    const productInfo = modal.querySelector(
      ".AreviewsModal_slider_info"
    );

    if (!productInfo) return;

    if (productInfo.querySelector("." + BUTTON_CLASS)) {
      return;
    }

    const button = document.createElement("button");

    button.type = "button";
    button.className = BUTTON_CLASS;

    button.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 24 24"
           fill="currentColor"
           aria-hidden="true">
        <path d="M12 4l-1.41 1.41L16.17 11H3v2h13.17l-5.58 5.59L12 20l8-8-8-8z"/>
      </svg>
      <span>ADICIONAR AO CARRINHO</span>
    `;

    button.addEventListener("click", () => {
      const productForm = getProductForm();

      if (!productForm) {
        alert("Não foi possível localizar o produto.");
        return;
      }

      const originalButton = productForm.querySelector(
        'button[type="submit"]'
      );

      if (
        !originalButton ||
        originalButton.disabled ||
        originalButton.getAttribute("aria-disabled") === "true"
      ) {
        alert("Selecione uma opção disponível do produto.");
        return;
      }

      button.disabled = true;

      button.querySelector("span").textContent =
        "ADICIONANDO...";

      const closeButton = modal.querySelector(
        "#AreviewsModal-close-button"
      );

      if (closeButton) {
        closeButton.click();
      }

      // Usa o formulário original do Shrine.
      originalButton.click();

      setTimeout(() => {
        button.disabled = false;

        const label = button.querySelector("span");

        if (label) {
          label.textContent = "ADICIONAR AO CARRINHO";
        }
      }, 1500);
    });

    productInfo.appendChild(button);
  }

  let scheduled = false;

  function scanModals() {
    document.querySelectorAll(
      ".AreviewsModal_modal__container"
    ).forEach(addButton);
  }

  function scheduleScan() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      scanModals();
    });
  }

  function initialize() {
    scanModals();

    const observer = new MutationObserver(scheduleScan);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
